
  import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'StockData',
})
  export default class StockData extends Vue {
  private fileUrl = '/templates/stock_template.xlsx'

  private downloadFile (): void {
    const link = document.createElement('a')
    link.href = this.fileUrl
    link.download = 'plantilla stock.xlsx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  private getFileName (url: string): string {
    return url.substring(url.lastIndexOf('/') + 1)
  }
  }
